<template>
  <div class="table-page-search-wrapper">
    <a-form :layout="layout">
      <a-row :gutter="gutter">
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="产品编号">
            <a-input placeholder="请输入产品编号" :allowClear="true" autocomplete="off" v-model="searchModel.number" />
          </a-form-item>
        </a-col>
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="产品名称">
            <a-input placeholder="请输入产品名称" :allowClear="true" autocomplete="off" v-model="searchModel.name" />
          </a-form-item>
        </a-col>
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="规格型号">
            <a-input placeholder="请输入规格型号" :allowClear="true" autocomplete="off" v-model="searchModel.spec" />
          </a-form-item>
        </a-col>
        <a-col :md="4" :sm="24">
          <span class="table-page-search-submitButtons">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'inquirySearchForm',
  mounted () {},
  computed: {
    ...mapState({}),
  },
  data () {
    return {
      layout: 'inline',
      gutter: 20,
      spanMd: 6,
      spanSm: 24,
      showExpend: true,

      searchModel: {},
      advanced: false, // 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      const model = this.searchModel
      if (model.name) {
        model.name = model.name.trim()
      }
      if (model.number) {
        model.number = model.number.trim()
      }
      if (model.spec) {
        model.spec = model.spec.trim()
      }
      for (var key in model) {
        if (!model[key] && model[key] !== 0) {
          delete model[key]
        }
      }
      this.$emit('setSearchCondition', model)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}

      this.$emit('clearSearch', this.searchModel)
    }
  }
}
</script>

<style scoped lang="less">
</style>